import { Injectable } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogueComponent, ConfirmDialogueAction } from '../components/confirmation-dialogue/confirmation-dialogue.component';

@Injectable({
  providedIn: 'root'
})
export class DialogueService {
  constructor(private modalService: NgbModal, private config: NgbModalConfig) {
    this.config.backdrop = 'static';
    this.config.keyboard = false;
  }

  Open(component: any, options: NgbModalOptions, data: any = {}) {
    const opts: NgbModalOptions = { backdrop: 'static', ...options };
    const modalRef = this.modalService.open(component, opts);
    modalRef.componentInstance.data = data; // Pass data here
    return modalRef;
  }

  GetConfirmation(title: string, message: string, action?: ConfirmDialogueAction): NgbModalRef {
    const modalRef = this.Open(ConfirmationDialogueComponent, { size: 'md' });
    modalRef.componentInstance.ConfirmationTitle = title;
    modalRef.componentInstance.ConfirmationMessage = message;
    modalRef.componentInstance.Action = action;
    return modalRef;
  }
}
